import { View } from "react-native";

type SeparatorProps = {
  withColor?: boolean;
  size?: "sm" | "md";
};

export default function Separator({
  withColor = false,
  size = "md",
}: SeparatorProps) {
  return (
    <View
      className={`h-[1px] ${withColor ? "bg-gray-200" : "bg-transparent"} ${
        size === "sm" ? "my-4" : "my-5"
      }`}
    />
  );
}
